import session from "@/api/session";

export default {
  getAddressByCode(postcode) {
    return session.get(`/gateway/tools/address-search/?postcode=${postcode}`);
  },
  fetchCurrentUser() {
    return session.get(`/crm-users/me/`);
  },
  getSearchItems(search) {
    return session.get(`/search/?querystring=${encodeURIComponent(search)}`);
  },
  getCRMUsers() {
    return session.get(`/crm-users/`);
  },
};
